module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exceed":"You have exceeded the number of interviews in your plan","variants":"You can","wait":"Wait for the next period to start","leftDays":"Days left","choose":"Choose plan","watch":"Upgrade your plan and see new applicants right now."}}')
  delete Component.options._Ctor
}
